export default {
  hours: {
    en: 'hours',
  },
  mins: {
    en: 'mins',
  },
  minutes: {
    en: 'minutes',
  },
  secs: {
    en: 'sec',
  },
  seconds: {
    en: 'seconds',
  },
}
